import * as React from "react"

import { cn } from "@/lib/utils"

const Card = React.forwardRef(/** @param {any} props */ ({ className, ...props }, ref) => (
  <div
    ref={ref} data-ui="card"
    className={cn("rounded-xl border bg-card text-card-foreground shadow", className)}
    {...props} />
))
Card.displayName = "Card"

const CardHeader = React.forwardRef(/** @param {any} props */ ({ className, ...props }, ref) => (
  <div
    ref={ref} data-ui="card-header"
    className={cn("flex flex-col space-y-1 p-4", className)}
    {...props} />
))
CardHeader.displayName = "CardHeader"

const CardTitle = React.forwardRef(/** @param {any} props */ ({ className, ...props }, ref) => (
  <div
    ref={ref} data-ui="card-title"
    className={cn("font-semibold leading-none tracking-tight", className)}
    {...props} />
))
CardTitle.displayName = "CardTitle"

const CardDescription = React.forwardRef(/** @param {any} props */ ({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("text-sm text-muted-foreground", className)}
    {...props} />
))
CardDescription.displayName = "CardDescription"

const CardContent = React.forwardRef(/** @param {any} props */ ({ className, ...props }, ref) => (
  <div ref={ref} data-ui="card-content" className={cn("p-4 pt-0", className)} {...props} />
))
CardContent.displayName = "CardContent"

const CardFooter = React.forwardRef(/** @param {any} props */ ({ className, ...props }, ref) => (
  <div
    ref={ref} data-ui="card-footer"
    className={cn("flex items-center p-4 pt-0", className)}
    {...props} />
))
CardFooter.displayName = "CardFooter"

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent }
